import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BookingCalendar = () => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());

  const bookings = [
    {
      id: 1,
      time: "09:00",
      customer: "Sarah Johnson",
      service: "Deep Cleaning",
      status: "confirmed",
      staff: "Mike Rodriguez",
      duration: "3 hours"
    },
    {
      id: 2,
      time: "13:30",
      customer: "Tech Solutions Inc",
      service: "Office Cleaning",
      status: "pending",
      staff: "Lisa Chen",
      duration: "2 hours"
    },
    {
      id: 3,
      time: "16:00",
      customer: "David Wilson",
      service: "Carpet Cleaning",
      status: "in-progress",
      staff: "Carlos Martinez",
      duration: "2.5 hours"
    }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'confirmed':
        return 'bg-success/10 text-success border-success/20';
      case 'pending':
        return 'bg-warning/10 text-warning border-warning/20';
      case 'in-progress':
        return 'bg-primary/10 text-primary border-primary/20';
      case 'completed':
        return 'bg-muted text-text-secondary border-border';
      default:
        return 'bg-muted text-text-secondary border-border';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'confirmed':
        return 'CheckCircle';
      case 'pending':
        return 'Clock';
      case 'in-progress':
        return 'Play';
      case 'completed':
        return 'Check';
      default:
        return 'Circle';
    }
  };

  const formatDate = (date) => {
    return date?.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const navigateDate = (direction) => {
    const newDate = new Date(currentDate);
    newDate?.setDate(newDate?.getDate() + (direction === 'next' ? 1 : -1));
    setCurrentDate(newDate);
    setSelectedDate(newDate);
  };

  return (
    <div className="bg-white rounded-lg border border-border">
      {/* Calendar Header */}
      <div className="flex items-center justify-between p-6 border-b border-border">
        <div>
          <h3 className="text-lg font-semibold text-text-primary">Booking Calendar</h3>
          <p className="text-sm text-text-secondary">{formatDate(selectedDate)}</p>
        </div>
        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="icon"
            onClick={() => navigateDate('prev')}
          >
            <Icon name="ChevronLeft" size={16} />
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => {
              const today = new Date();
              setCurrentDate(today);
              setSelectedDate(today);
            }}
          >
            Today
          </Button>
          <Button
            variant="outline"
            size="icon"
            onClick={() => navigateDate('next')}
          >
            <Icon name="ChevronRight" size={16} />
          </Button>
        </div>
      </div>
      {/* Bookings List */}
      <div className="p-6">
        {bookings?.length === 0 ? (
          <div className="text-center py-8">
            <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="Calendar" size={32} color="var(--color-text-secondary)" />
            </div>
            <h4 className="text-lg font-medium text-text-primary mb-2">No bookings today</h4>
            <p className="text-text-secondary">Schedule is clear for this date</p>
          </div>
        ) : (
          <div className="space-y-4">
            {bookings?.map((booking) => (
              <div
                key={booking?.id}
                className="flex items-center justify-between p-4 bg-surface rounded-lg border border-border hover:shadow-elevation-1 transition-shadow duration-200"
              >
                <div className="flex items-center space-x-4">
                  <div className="text-center">
                    <div className="text-lg font-semibold text-text-primary">
                      {booking?.time}
                    </div>
                    <div className="text-xs text-text-secondary">
                      {booking?.duration}
                    </div>
                  </div>
                  
                  <div className="flex-1">
                    <h4 className="font-medium text-text-primary">{booking?.customer}</h4>
                    <p className="text-sm text-text-secondary">{booking?.service}</p>
                    <div className="flex items-center space-x-2 mt-1">
                      <Icon name="User" size={12} />
                      <span className="text-xs text-text-secondary">{booking?.staff}</span>
                    </div>
                  </div>
                </div>

                <div className="flex items-center space-x-3">
                  <div className={`flex items-center space-x-2 px-3 py-1 rounded-full border text-xs font-medium ${getStatusColor(booking?.status)}`}>
                    <Icon name={getStatusIcon(booking?.status)} size={12} />
                    <span className="capitalize">{booking?.status?.replace('-', ' ')}</span>
                  </div>
                  
                  <div className="flex items-center space-x-1">
                    <Button variant="ghost" size="icon" className="w-8 h-8">
                      <Icon name="Edit" size={14} />
                    </Button>
                    <Button variant="ghost" size="icon" className="w-8 h-8">
                      <Icon name="MoreVertical" size={14} />
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BookingCalendar;